import axios from 'axios'
import { MessageBox } from 'element-ui'
import router from '@router'
// 发送请求后10秒还没有响应就超时报错
axios.defaults.timeout = 5000
// 拦截请求
axios.interceptors.request.use(config => {
  // loading
  return config
}, error => {
  return Promise.reject(error)
})
// 拦截响应
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401) {
    MessageBox.confirm('登录超时是否退出登录?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      router.push('/login')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('authorization')
    })
  }
  if (error.response.status === 502 || error.response.status === 501 || error.response.status === 500) {
    MessageBox.confirm('网络请求异常，请稍后再试！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {})
  }
  return Promise.resolve(error.response)
})
const ajax = {
  post (url, data, header) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, {headers: {
        Authorization: 'Bearer ' + header
      }}).then(res => {
        let { data, status } = res
        if (status === 200) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(data => reject(data))
    })
  },
  get (url, header) {
    return new Promise((resolve, reject) => {
      axios.get(url, {headers: {
        Authorization: 'Bearer ' + header
      }}).then(res => {
        let { data, status } = res
        if (status === 200) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(data => reject(data))
    })
  },
  put (url, data, header) {
    return new Promise((resolve, reject) => {
      axios.put(url, data, header ? {headers: {
        Authorization: 'Bearer ' + header
      }} : null).then(res => {
        let { data, status } = res
        if (status === 200) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(data => reject(data))
    })
  },
  patch (url, data, header) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data, {headers: {
        Authorization: 'Bearer ' + header
      }}).then(res => {
        let { data, status } = res
        if (status === 200) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(data => reject(data))
    })
  },
  delete (url, header) {
    return new Promise((resolve, reject) => {
      axios.delete(url, {headers: {
        Authorization: 'Bearer ' + header
      }}).then(res => {
        let { data, status } = res
        if (status === 200) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(data => reject(data))
    })
  }
}
export default ajax



// WEBPACK FOOTER //
// ./src/api/ajax/ajax.js